/* =====================================================================
   mb-product.js — Baseline 2.6.1 custom product section
   Handles: desktop thumbnail scroll-spy + click, mobile dot indicators,
   quantity stepper, ATC toast notification, SS header cart count update.
   ===================================================================== */

/* ── Gate: only show toast when user actually clicked ATC on this page ── */
var _mbUserClickedATC = false;

document.addEventListener('click', function (e) {
  if (e.target.closest('#addToCartButton, button[name="add"], .add-to-cart')) _mbUserClickedATC = true;
}, true);

/* ── Fetch intercept for 422 stock-limit case ──
   Uses clone() so Baseline's original response is completely untouched.
   We only READ the cloned copy — never modify or re-use the original. ── */
(function () {
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      result.then(function (response) {
        if (response.status === 422 && _mbUserClickedATC) {
          _mbUserClickedATC = false;
          response.clone().json().then(function (data) {
            var section = document.querySelector('.mb-product-section');
            var productJson = document.querySelector('[data-product-json]');
            var product = productJson ? JSON.parse(productJson.textContent) : null;
            var title = product ? product.title : '';
            var imgUrl = '';
            if (product) {
              var variantSelect = section.querySelector('[x-ref="singleVariantSelector"]');
              var variantId = variantSelect ? parseInt(variantSelect.value, 10) : null;
              var featuredImage = null;
              if (product.variants && variantId) {
                var v = product.variants.find(function (v) { return v.id === variantId; });
                if (v && v.featured_image) featuredImage = v.featured_image;
              }
              if (!featuredImage && product.featured_image) featuredImage = { src: product.featured_image };
              if (featuredImage) {
                var u = featuredImage.src || featuredImage.url || '';
                if (u.startsWith('//')) u = 'https:' + u;
                u = u.split('?')[0];
                if (u.indexOf('/cdn/shop/products/') !== -1) {
                  u = u.replace(/_\d+x\d*(\.[a-zA-Z]+)$/, '$1');
                  u = u.replace(/(\.[a-zA-Z]+)$/, '_160x213$1');
                }
                imgUrl = u;
              }
            }
            /* Get the qty actually in cart for this variant */
            if (!title) return;
            var variantSelect = document.querySelector('[x-ref="singleVariantSelector"]');
            var variantId = variantSelect ? parseInt(variantSelect.value, 10) : null;
            origFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var qty = 1;
              if (variantId && cart.items) {
                var cartItem = cart.items.find(function (i) { return i.variant_id === variantId; });
                if (cartItem) qty = cartItem.quantity;
              }
              window._mbShowToast(title, imgUrl, qty);
            }).catch(function () { window._mbShowToast(title, imgUrl, 1); });
          }).catch(function () {});
        }
      });
    }
    return result;
  };
})();


(function () {
  'use strict';

  const DESKTOP_BP = 1024;

  function init(section) {
    /* ── Sticky text height = viewport height (desktop only) ── */
    const stickyText = section.querySelector('.mb-sticky-text');
    if (stickyText) {
      const syncHeight = () => {
        stickyText.style.height = window.innerWidth >= DESKTOP_BP
          ? window.innerHeight + 'px'
          : '';
      };
      syncHeight();
      window.addEventListener('resize', syncHeight, { passive: true });
      window.addEventListener('orientationchange', syncHeight, { passive: true });
    }

    /* ── Desktop thumbnails ── */
    const thumbs = Array.from(section.querySelectorAll('.mb-thumb'));
    const items  = Array.from(section.querySelectorAll('.mb-media-item'));

    function headerH() {
      const cs = getComputedStyle(document.documentElement);
      return parseFloat(cs.getPropertyValue('--header-height')) || 66;
    }

    function setThumbActive(idx) {
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    thumbs.forEach(btn => {
      btn.addEventListener('click', () => {
        if (window.innerWidth < DESKTOP_BP) return;
        const idx = parseInt(btn.dataset.index, 10);
        const target = items[idx];
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - headerH() - 20;
        window.scrollTo({ top, behavior: 'smooth' });
        setThumbActive(idx);
      });
    });

    /* IntersectionObserver scroll-spy → update active thumbnail */
    if ('IntersectionObserver' in window && thumbs.length && items.length) {
      const io = new IntersectionObserver(entries => {
        if (window.innerWidth < DESKTOP_BP) return;
        let best = null;
        entries.forEach(en => {
          if (en.isIntersecting) {
            if (!best || en.boundingClientRect.top < best.boundingClientRect.top) best = en;
          }
        });
        if (best) {
          const idx = parseInt(best.target.dataset.index, 10);
          if (!Number.isNaN(idx)) setThumbActive(idx);
        }
      }, {
        root: null,
        rootMargin: `-${headerH() + 20}px 0px -55% 0px`,
        threshold: 0
      });
      items.forEach(it => io.observe(it));
    }

    /* ── Mobile dot indicators ── */
    const mobImages = section.querySelector('.mb-mobile-images');
    const dotStrip  = section.querySelector('.mb-dot-strip');

    if (mobImages && dotStrip) {
      const mobItems = Array.from(mobImages.querySelectorAll('.mb-mobile-img-item'));

      mobItems.forEach((_, i) => {
        const d = document.createElement('span');
        d.className = 'mb-dot' + (i === 0 ? ' is-active' : '');
        dotStrip.appendChild(d);
      });
      const dots = Array.from(dotStrip.querySelectorAll('.mb-dot'));

      function setDotActive(idx) {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }

      if ('IntersectionObserver' in window && mobItems.length) {
        const mobIO = new IntersectionObserver(entries => {
          entries.forEach(en => {
            if (en.isIntersecting) {
              const idx = mobItems.indexOf(en.target);
              if (idx !== -1) setDotActive(idx);
            }
          });
        }, { root: mobImages, threshold: 0.5 });
        mobItems.forEach(it => mobIO.observe(it));
      }
    }

    /* ── Quantity stepper ── */
    const qtyInput = section.querySelector('.mb-quantity-input input[type="number"]');
    const minusBtn = section.querySelector('.mb-qty-btn[name="minus"]');
    const plusBtn  = section.querySelector('.mb-qty-btn[name="plus"]');

    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', () => {
        if (+qtyInput.value > 1) qtyInput.value = +qtyInput.value - 1;
      });
      plusBtn.addEventListener('click', () => {
        qtyInput.value = +qtyInput.value + 1;
      });
    }

    section._mbPending = {
      getQty: function () {
        return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      }
    };
  }

  /* Boot on all product sections present at load */
  function boot() {
    document.querySelectorAll('.mb-product-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init when Shopify reloads the section in the theme editor */
  document.addEventListener('shopify:section:load', e => {
    const sec = e.target.querySelector('.mb-product-section');
    if (sec) init(sec);
  });

  /* ── Toast ─────────────────────────────────────────────────────────── */
  let toastTimer = null;
  let toastEl    = null;

  function getOrCreateToast() {
    if (toastEl) return toastEl;

    toastEl = document.createElement('div');
    toastEl.id        = 'mb-toast';
    toastEl.className = 'mb-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.setAttribute('aria-atomic', 'true');

    toastEl.innerHTML =
      '<div class="mb-toast-inner">' +
        '<div class="mb-toast-img-wrap"><img class="mb-toast-img" src="" alt="" aria-hidden="true"></div>' +
        '<div class="mb-toast-body">' +
          '<div class="mb-toast-title"></div>' +
          '<div class="mb-toast-label">Added to cart</div>' +
          '<div class="mb-toast-qty"></div>' +
          '<a href="/cart" class="mb-toast-link">View cart</a>' +
        '</div>' +
        '<button type="button" class="mb-toast-close" aria-label="Close">×</button>' +
      '</div>';

    toastEl.querySelector('.mb-toast-close').addEventListener('click', dismissToast);
    toastEl.addEventListener('mouseenter', function () {
      if (toastTimer) clearTimeout(toastTimer);
    });
    toastEl.addEventListener('mouseleave', function () {
      if (toastEl.classList.contains('mb-toast--visible')) {
        toastTimer = setTimeout(dismissToast, 2000);
      }
    });

    const header = document.querySelector('#shopify-section-ss-header-11, .shopify-section-header, header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(toastEl, header.nextSibling);
    } else {
      document.body.prepend(toastEl);
    }

    return toastEl;
  }

  function buildImgUrl(item) {
    const url = (item.featured_image && item.featured_image.url) || item.image || '';
    return normaliseImgUrl(url);
  }

  function showToast(productTitle, imgUrl, qty) {
    const toast = getOrCreateToast();
    const inner = toast.querySelector('.mb-toast-inner');

    /* Build single-product layout */
    inner.innerHTML =
      '<div class="mb-toast-img-wrap"><img class="mb-toast-img" src="" alt="" aria-hidden="true"></div>' +
      '<div class="mb-toast-body">' +
        '<div class="mb-toast-title"></div>' +
        '<div class="mb-toast-label">Added to cart</div>' +
        '<div class="mb-toast-qty"></div>' +
        '<a href="/cart" class="mb-toast-link">View cart</a>' +
      '</div>' +
      '<button type="button" class="mb-toast-close" aria-label="Close">×</button>';

    inner.querySelector('.mb-toast-close').addEventListener('click', dismissToast);
    inner.querySelector('.mb-toast-title').textContent = productTitle || '';
    inner.querySelector('.mb-toast-qty').textContent   = 'Qty: ' + (qty || 1);

    const wrap = inner.querySelector('.mb-toast-img-wrap');
    const img  = inner.querySelector('.mb-toast-img');
    if (imgUrl) {
      img.onload  = function () { wrap.style.display = ''; };
      img.onerror = function () { wrap.style.display = 'none'; };
      wrap.style.display = '';
      img.src = imgUrl;
      img.alt = productTitle || '';
    } else {
      img.src = '';
      wrap.style.display = 'none';
    }

    if (toastTimer) clearTimeout(toastTimer);
    toast.classList.add('mb-toast--visible');
    toastTimer = setTimeout(dismissToast, 3500);
  }

  function normaliseImgUrl(url) {
    if (!url) return '';
    if (url.startsWith('//')) url = 'https:' + url;
    url = url.split('?')[0];
    if (url.indexOf('/cdn/shop/products/') !== -1) {
      url = url.replace(/_\d+x\d*(\.[a-zA-Z]+)$/, '$1');
      url = url.replace(/(\.[a-zA-Z]+)$/, '_160x213$1');
    }
    return url;
  }

  window._mbShowToast = showToast;

  function dismissToast() {
    if (toastTimer) clearTimeout(toastTimer);
    if (toastEl) toastEl.classList.remove('mb-toast--visible');
  }

  function handleAddToCart(count) {
    const section = document.querySelector('.mb-product-section');

    const pending = section && section._mbPending;
    const qty = pending ? pending.getQty() : 1;

    let productTitle = '';
    let imgUrl = '';
    try {
      const productJson   = document.querySelector('[data-product-json]');
      const variantSelect = document.querySelector('[x-ref="singleVariantSelector"]');
      const product       = productJson ? JSON.parse(productJson.textContent) : null;
      const variantId     = variantSelect ? parseInt(variantSelect.value, 10) : null;

      productTitle = product ? product.title : '';

      let featuredImage = null;
      if (product && product.variants && variantId) {
        const v = product.variants.find(function (v) { return v.id === variantId; });
        if (v && v.featured_image) featuredImage = v.featured_image;
      }
      if (!featuredImage && product && product.featured_image) {
        featuredImage = { src: product.featured_image };
      }
      imgUrl = buildImgUrl({
        featured_image: featuredImage ? { url: featuredImage.src || featuredImage.url || '' } : null
      });
      if (productTitle) showToast(productTitle, imgUrl, qty);
    } catch (e) {}

    /* Update header cart count */
    if (count !== undefined) {
      document.querySelectorAll('.cart-count-bubble span').forEach(function (el) {
        el.textContent = '(' + count + ')';
      });
      if (window.Spruce) {
        try { window.Spruce.store('cartCount').count = count; } catch (_) {}
      }
    } else {
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = cart.item_count;
          document.querySelectorAll('.cart-count-bubble span').forEach(function (el) {
            el.textContent = '(' + c + ')';
          });
          if (window.Spruce) {
            try { window.Spruce.store('cartCount').count = c; } catch (_) {}
          }
        })
        .catch(function () {});
    }
  }

  document.body.addEventListener('baseline:modalcart:afteradditem', function () {
    if (!_mbUserClickedATC) return;
    /* Let mb-bundle.js handle it on bundle pages */
    if (document.querySelector('.mb-bundle-section')) return;
    _mbUserClickedATC = false;
    handleAddToCart(undefined);
  });

  document.body.addEventListener('baseline:modalcart:itemcountupdate', function (e) {
    if (!_mbUserClickedATC) return;
    /* Let mb-bundle.js handle it on bundle pages */
    if (document.querySelector('.mb-bundle-section')) return;
    _mbUserClickedATC = false;
    const count = e && e.detail && e.detail.count;
    handleAddToCart(count);
    try {
      if (window.Alpine && Alpine.store('drawer')) {
        Alpine.store('drawer').cartDrawerOpen = false;
      }
    } catch (_) {}
  });

  /* Reset flag on Baseline error so it doesn't get stuck */
  document.body.addEventListener('baseline:modalcart:error', function () {
    _mbUserClickedATC = false;
  });

})();